import {
    requestAllReqBuys,
    requestSaveReqBuy,
    requestDeleteReqBuy,
    requestSubmitSignForm,
    requstSignOffHistory
} from "@/api/req-buy-api";

const actions = {

    async getAllReqBuys({commit}, data) {
        let result = await requestAllReqBuys(data)
        if (result.code === '200') {
            return result
        } else {
            return Promise.reject(new Error('無法取得資料'))
        }
    },

    async saveReqBuy({commit}, data) {
        let result = await requestSaveReqBuy(data)
        if (result.code === '200') {
            return result.message
        } else {
            return Promise.reject(new Error('資料更新失敗'))
        }
    },

    async deleteReqBuy({commit}, data) {
        let result = await requestDeleteReqBuy(data)
        if (result.code === '200') {
            return result.message
        } else {
            return Promise.reject(new Error('資料刪除失敗'))
        }
    },

    async submitSignForm({commit}, data) {
        let result = await requestSubmitSignForm(data)
        if (result.code === '200') {
            return result.message
        } else {
            return Promise.reject(new Error('簽核送出失敗'))
        }
    },

    async getSignOffHistory({commit}, id) {
        let result = await requstSignOffHistory(id)
        if (result.code === '200') {
            return result
        } else {
            return Promise.reject(new Error('取得簽核紀錄失敗'))
        }
    }
}

const mutations = {}
const state = {}
const getters = {}

export default {
    namespaced: true,
    actions,
    mutations,
    state,
    getters
}
